import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

import {
  postLicenseFile,
  clearLicenseErrors,
  setLicenseErrors,
  clearLicenseData,
  getControlInfoExists,
} from './state/actions';

import { Main, Filter } from 'Containers';
import LicenseForm from './components/LicenseForm';
import { NotificationMessage } from 'Components';
import { IMPORT_LICENSE_FORM } from 'Common/FormEnum';

class LicenseContainer extends Component {
  componentWillMount() {
    this.props.getControlInfoExists();
  }

  componentDidUpdate(prevProps) {
    const { license } = this.props;
    if (prevProps.license !== license) {
      if (license.Errors !== undefined && license.Errors.length > 0) {
        NotificationMessage(license);
      }
    }
  }

  handleSubmit = data => {
    const {
      clearLicenseErrors,
      clearLicenseData,
      setLicenseErrors,
      licenseExists,
      postLicenseFile,
    } = this.props;

    clearLicenseErrors();
    clearLicenseData();

    if (data.fiscalyear === undefined && !licenseExists) {
      setLicenseErrors('Please choose a starting fiscal year.');
      return;
    }

    if (data.license_file === undefined || data.license_file.length === 0) {
      setLicenseErrors('Please choose a file.');
      return;
    }

    if (data.license_file[0].size > 1000000) {
      setLicenseErrors('File size must be less than 1MB.');
      return;
    }

    let formData = new FormData();
    formData.append('name', data.name);
    formData.append('license_file', data.license_file[0]);

    postLicenseFile(
      formData,
      data.fiscalyear === undefined ? 0 : data.fiscalyear
    ).then(result => {
      NotificationMessage(result);
    });
  };

  renderLink() {
    if (this.props.licenseExists) {
      return (
        <Link to="/assignlicense">Assign your license to a specific site</Link>
      );
    }
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: IMPORT_LICENSE_FORM,
        saveButtonProps: {
          content: 'Submit',
        },
        shown: true,
      },
    };
  };

  render() {
    const { licenseExists, clearLicenseErrors } = this.props;

    if (licenseExists === undefined) {
      return <Loader active inline="centered" />;
    }

    return (
      <Fragment>
        <Filter title={'Import License'} />
        <Main {...this.getMainProps()}>
          <LicenseForm
            onSubmit={this.handleSubmit}
            initialValues={{ file_name: '', license_file: undefined }}
            clearLicenseErrors={clearLicenseErrors}
            displayFiscalYear={!licenseExists}
          />
          <br />
          {this.renderLink()}
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ LicenseState }) => {
  return {
    license: LicenseState.license,
    licenseExists: LicenseState.licenseExists,
  };
};

export const License = connect(
  mapStateToProps,
  {
    postLicenseFile,
    clearLicenseErrors,
    setLicenseErrors,
    clearLicenseData,
    getControlInfoExists,
  }
)(LicenseContainer);



// WEBPACK FOOTER //
// ./src/pages/license/License.js